export default "__VITE_ASSET__DUvbubgE__"